export const environment = {
  production: false,
  apiUrl: 'https://api.muzrus.stage.oldhowl.ru',
  staticUrl: 'https://api.muzrus.stage.oldhowl.ru',
  domainUrl: 'https://muzrus.com.oldhowl.ru'
};

// For debugging
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
